module.exports = __webpack_public_path__ + "media/img/payment-methods/maestro-36ed24ace9eeb73e3b8cd093bc77c959.svg";